export const DRAG_HANDLE_ELEMENT = 'drag-handle';
